module.exports = __webpack_public_path__ + "img/starwars3.0b812b35.jpg";